import { memo, useMemo } from "react";

import { addDate } from "@/lib/dayjs/add/add-date";
import { formatDate } from "@/lib/dayjs/format-date";

import { BasicInfoLabelWithTextLayout } from "../../layout";

import type { QueryData } from "../../../model";

type Props = {
	aliveItemsPerDate: QueryData["aliveItemsPerDate"];
	isDayTrip: boolean;
};

export const DateOfBasicInfoCompositions = memo(({ aliveItemsPerDate, isDayTrip }: Props) => {
	const dateText = useMemo(() => {
		if (aliveItemsPerDate.length === 0) return "";

		const startAliveItemPerDate = aliveItemsPerDate[0];
		let totalDate = formatDate(startAliveItemPerDate.date, "YYYY年MM月DD日(ddd)");

		/**
		 * 日帰り
		 */
		if (isDayTrip) return totalDate;

		/**
		 * 滞在日数
		 */
		const numberOfDates = aliveItemsPerDate.length;
		/**
		 * 泊数
		 */
		const numberOfNights = numberOfDates - 1;

		const isDayANight = numberOfDates === 1;
		if (isDayANight) {
			/**
			 * 1泊2日
			 */
			const lastDate = addDate({ date: startAliveItemPerDate.date, inc: 1, format: "YYYY年MM月DD日(ddd)" });
			totalDate += `〜${lastDate}`;
		} else {
			/**
			 * 2泊以上
			 */
			const lastDate = addDate({
				date: startAliveItemPerDate.date,
				inc: numberOfNights,
				format: "YYYY年MM月DD日(ddd)",
			});
			totalDate += `〜${lastDate}`;
		}

		totalDate += ` [${numberOfNights}泊${numberOfDates}日]`;

		return totalDate;
	}, [aliveItemsPerDate, isDayTrip]);

	return <BasicInfoLabelWithTextLayout label="日程" textChildren={<p>{dateText}</p>} />;
});
